export default (state = [], action) => {
  switch (action.type) {
    case 'COUNCILS_DATA:SUCCESS': {
      return {
        ...state,
        councilsData: action.payload,
      };
    }
    case 'COUNCILS_QLD_GEO:SUCCESS': {
      return {
        ...state,
        qldCouncilsGeo: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};

export const getCouncilsData = state => state.councilsData;
export const getQldCouncilsGeo = state => state.qldCouncilsGeo;



// WEBPACK FOOTER //
// ./src/reducers/councils.js